module.exports = __webpack_public_path__ + "img/zo.1765b71d.jpg";